<template>
  <el-dialog
    :title="`Список перевозчиков для перевозки №${id}`"
    :visible="visible"
    width="80%"
    custom-class="responses-list-modal"
    @close="beforeClose"
  >
    <el-table v-loading="isLoading" :data="table.info" empty-text="Нет данных">
      <el-table-column
        fixed
        prop="person"
        label="ИП перевозчик, телефон, авто"
        width="500"
      />
      <el-table-column label="Дни">
        <el-table-column
          v-for="(day, i) in table.days"
          :key="`${day}_${i}`"
          :prop="day"
          :label="day"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            <b :class="['symbol', { plus: scope.row[day] }]">
              {{ scope.row[day] || '-' }}
            </b>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ResponsesListModal',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({ getLoading: 'bids/getLoading', bid: 'bids/getBid' }),
    isLoading() {
      return this.getLoading('Map')
    },
    table() {
      const persons = {}
      const days = []

      if (this.bid['load-days']) {
        this.bid['load-days'].map(d => {
          const day = this.dateToFormat(d.load_date, 'shortDateWithoutYear')

          days.push(day)

          if (d.responses.length) {
            d.responses.map(r => {
              const { automobile, driver } = r
              const { id, state_numbers, carrier_name } = automobile
              const { phone } = driver

              if (!persons[id]) {
                persons[id] = {
                  person: `${carrier_name || '(нет данных)'},
                   ${state_numbers || '(нет данных)'},
                    ${phone || '(нет данных)'}`,
                }
              }
              persons[id][day] = '+'
            })
          }
        })
      }
      const info = Object.values(persons).sort(this.sorting)

      return { info, days }
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.visible) {
          this.fetchBidForMap(newVal)
        }
      },
    },
  },

  methods: {
    ...mapActions('bids', ['fetchBidForMap']),
    sorting(a, b) {
      return Object.keys(b).length - Object.keys(a).length
    },
    beforeClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="sass">
.home .responses-list-modal
  .el-dialog__header
    padding: 20px 40px
    color: #000
  .el-dialog__body
    padding: 0 40px 40px
    color: #000
  .el-table th
    display: table-cell !important
  .symbol
    font-size: 20px
    color: #ff0000
    &.plus
      color: #46d26c
</style>
